<div class="container postulacion-container mb-5">
<!--     <div class="row header-postulacion-container">
        <div class="col-12">{{'jobaplication-for' | translate}}</div>
        <div class="col-12">
            <h4>{{jobOpeningSelected?.vacant}}</h4>
        </div>
        <div>
            <span><b>{{jobOpeningSelected?.salaryRange}}</b> | {{jobOpeningSelected?.enterpriseName}} |
                {{jobOpeningSelected?.location}} | {{jobOpeningSelected?.strStarDate}}</span>
        </div>
    </div> -->
    <div class="row mt-2 info-postulacion-container justify-content-center">
        <div [class.col-7][ngClass]="{'col-12 col-md-7':esRegistro}" class="mr-2 job-apply-card">
			<div class="container">
				<div class="card w-100 w-lg-50 mx-auto">
					<div class="card-body">
						<ng-container *ngIf="isLoggedIn$ | async as isLoggedIn; else notLoggedIn">
							<h4 class="fw-bold mb-4">¡Qué alegría verte de nuevo, <span class="text-primary">{{nombre + ' ' + primerApellido + ' ' + segundoApellido}}</span>!</h4>
						</ng-container>

						<ng-template #notLoggedIn>
							<div class="card-title mb-4">
								<h4 class="fw-bold mb-4">¡Bienvenido(a)!, <span class="text-primary">Compártenos tus datos</span>!</h4>
							</div>
						</ng-template>

						<!-- Mensaje de éxito -->
						<div class="alert alert-success d-flex align-items-center" role="alert" *ngIf="mensajeExito">
							<i class="bi bi-check-circle-fill me-2"></i>
							<div>
								<strong>¡Registro exitoso!</strong>
								<p class="mb-0">{{mensajeExito}}</p>
							</div>
						</div>

						<!-- Mensaje de error -->
						<div class="alert alert-danger d-flex align-items-center" role="alert" *ngIf="mensajeError">
							<i class="bi bi-exclamation-triangle-fill me-2"></i>
							<div>
								<strong>Error al registrar</strong>
								<p class="mb-0">{{mensajeError}}</p>
							</div>
						</div>

						<form class="align-self-center" [formGroup]="registroForm" (ngSubmit)="onSubmit()">

								<div class="mb-3 row">
									<div class="col-md-4">
										<label class="form-label">Nombre(s)</label>
										<div class="input-group">
											<input type="text" class="form-control" id="nombre" formControlName="nombre"
											placeholder="Nombre(s)" [(ngModel)]="nombre">
										</div>
										<div *ngIf="registroForm.controls['nombre'].invalid && registroForm.controls['nombre'].touched" class="text-danger">
											<small *ngIf="registroForm.controls['nombre'].errors?.['required']">El nombre es obligatorio</small>
											<small *ngIf="registroForm.controls['nombre'].errors?.['minlength']">Mínimo 5 caracteres</small>
											<small *ngIf="registroForm.controls['nombre'].errors?.['pattern']">
											  Solo se permiten letras y números.
											</small>
										</div>
									</div>

									<div class="col-md-4">
										<label class="form-label">Apellido paterno</label>
										<input type="text" class="form-control" id="primer-apellido" formControlName="primerApellido"
											placeholder="Apellido paterno" [(ngModel)]="primerApellido">
										<div *ngIf="registroForm.controls['primerApellido'].invalid && registroForm.controls['primerApellido'].touched"
											class="text-danger">
											<small *ngIf="registroForm.controls['primerApellido'].errors?.['required']">El apellido paterno es obligatorio</small>
											<small *ngIf="registroForm.controls['primerApellido'].errors?.['minlength']">Mínimo 5 caracteres</small>
											<small *ngIf="registroForm.controls['primerApellido'].errors?.['pattern']">
											  Solo se permiten letras y números.
											</small>
										</div>
									</div>

									<div class="col-md-4">
										<label class="form-label">Apellido materno</label>
										<input type="text" class="form-control" id="segundo-apellido" formControlName="segundoApellido"
											placeholder="Apellido materno" [(ngModel)]="segundoApellido">
										<div *ngIf="registroForm.controls['segundoApellido'].invalid && registroForm.controls['segundoApellido'].touched"
											class="text-danger">
											<small *ngIf="registroForm.controls['segundoApellido'].errors?.['required']">El apellido materno es obligatorio</small>
											<small *ngIf="registroForm.controls['segundoApellido'].errors?.['minlength']">Mínimo 2 caracteres</small>
											<small *ngIf="registroForm.controls['segundoApellido'].errors?.['pattern']">
											  Solo se permiten letras y números.
											</small>
										</div>
									</div>
								</div>

								<div class="mb-3 row">
									<div class="col-sm-6">
										<label for="email" class="form-label">Correo electrónico:</label>
										<input type="email" class="form-control" id="email" formControlName="email" placeholder="Correo electrónico" [(ngModel)]="email">
										<ul *ngIf="emailSuggestions.length" class="list-group mt-1">
											<li class="list-group-item list-group-item-action"
												*ngFor="let suggestion of emailSuggestions" (click)="setEmail(suggestion)">
												{{ suggestion }}
											</li>
										</ul>
										<div *ngIf="registroForm.controls['email'].invalid && registroForm.controls['email'].touched"
											class="text-danger">
											<small *ngIf="registroForm.controls['email'].errors?.['required']">El email es obligatorio</small>
											<small *ngIf="registroForm.controls['email'].errors?.['email']">Formato de email inválido</small>
										</div>
									</div>
								
									<div class="col-sm-6">
										<label for="celular" class="form-label">Teléfono celular:</label>
										<input type="tel" class="form-control" id="celular" formControlName="celular" placeholder="Teléfono celular" [(ngModel)]="celular">

									<!-- Mensajes de error (segunda línea visual) -->
									<div class="text-danger mt-1" *ngIf="registroForm.controls['celular'].touched">
										<small *ngIf="registroForm.controls['celular'].errors?.['required']">El celular es obligatorio.</small>
										<small *ngIf="registroForm.controls['celular'].errors?.['pattern']">Debe ser un número de 10 dígitos.</small>
										<small *ngIf="registroForm.controls['celular'].errors?.['invalidLength']">El número debe tener exactamente 10 dígitos.</small>
									</div>
									</div>

								</div>

								<div class="mb-3 row">
									<div class="col-sm-6">
										<label for="fechaNacimiento" class="form-label">Fecha de nacimiento:</label>
										<input type="date" class="form-control" id="fechaNacimiento" formControlName="fechaNacimiento"
											placeholder="Fecha de nacimiento" [(ngModel)]="fechaNacimiento">
										<div *ngIf="registroForm.controls['fechaNacimiento'].invalid && registroForm.controls['fechaNacimiento'].touched"
											class="text-danger">
											<small *ngIf="registroForm.controls['fechaNacimiento'].errors?.['required']">La fecha de nacimiento es obligatoria</small>
										</div>
									</div>

									<div class="col-sm-6">
										<label for="pretensiones" class="form-label">Sueldo deseado:</label>
										<ng-select 
											[items]="catalogoSueldos" 
											bindLabel="sueldo" 
											bindValue="idSueldo"
											[(ngModel)]="pretensiones" 
											[multiple]="false" 
											class="form-select" 
											id="pretensiones"
											formControlName="pretensiones"
											>
										</ng-select>
										<div *ngIf="registroForm.controls['pretensiones'].invalid && registroForm.controls['pretensiones'].touched"
											class="text-danger">
											<small *ngIf="registroForm.controls['pretensiones'].errors?.['required']">El sueldo deseado es obligatorio</small>
										</div>
									</div>
								</div>

								<div class="mb-3 row">
									<div class="col-sm-6">
										<label for="giroEmpleo" class="form-label">Giro:</label>
										<input type="text" class="form-control" id="giroEmpleo" formControlName="giroEmpleo"
											placeholder="Giro" [(ngModel)]="giroEmpleo">
										<div *ngIf="registroForm.controls['giroEmpleo'].invalid && registroForm.controls['giroEmpleo'].touched"
											class="text-danger">
											<small *ngIf="registroForm.controls['giroEmpleo'].errors?.['required']">El giro es obligatorio</small>
										</div>
									</div>

									<div class="col-sm-6">
										<label for="experiencia" class="form-label">Tiempo de experiencia:</label>
										<input type="number" class="form-control" id="experiencia" formControlName="experiencia"
											placeholder="Años de experiencia" [(ngModel)]="experiencia" min="0">
										<div *ngIf="registroForm.controls['experiencia'].invalid && registroForm.controls['experiencia'].touched"
											class="text-danger">
											<small *ngIf="registroForm.controls['experiencia'].errors?.['required']">El tiempo de experiencia es obligatorio</small>
										</div>
									</div>
								</div>

							<!-- Campo oculto para positionId si hay vacante -->
							<input type="hidden" formControlName="positionId" [(ngModel)]="positionId" *ngIf="vacante?.requisicion">

							<br />

							<!-- Botón Enviar -->
							<div class="d-grid gap-2">
								<button 
									type="submit" 
									class="btn btn-primary btn-lg fw-semibold" 
									[disabled]="registroForm.invalid || isLoading">
									<span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
									{{ isLoading ? 'Enviando...' : 'Enviar' }}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>